import { tns } from "./../node_modules/tiny-slider/src/tiny-slider"

window.addEventListener('load', () => {
  let tinySliderInstance;

  const sliderHeader = document.querySelector('.wp-block-cover.-has-tiny-slider');

  if (sliderHeader) {
    tinySliderInstance = tns({
      container: '.tiny-slider',
      mode: "gallery",
      items: 1,
      autoplay: true,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      loop: true,
      controls: false,
      nav: false,
      autoplayButton: false,
      autoplayButtonOutput: false
    });
  }
});
